import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbStatic = [{
	name: 'Business Cards',
	url: '/business_cards',
	icon: 'clipboard'
}];

export default class Business_Cards extends Framework.Components.View {
	constructor(props) {
		super(props);
		this.state.current_address = null;
	}

	render() {
		let {history, roles, user, main_role} = this.props;
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}>
					<Button data-cy="add-request" onClick={this.toggle('modalCards')} size={"sm"} color="primary">
						Request Marketing Materials
					</Button>
				</Framework.Components.PageBar>
				<div className={"row"}>
					<div className={"col"}>
						<Collections.BusinessCards
							key={this.state.key}
							history={history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={roles.includes(UserRoles.Admin)}
							user={user}
							main_role={main_role}
							read_only={main_role === UserRoles.FieldEngineer}
							setCurrentAddress={(current_address) => this.setState({current_address})}
						/>
					</div>
				</div>

				<Framework.Elements.UniversalModal
					title={"Request Marketing Materials"}
					object={Objects.BusinessCard}
					history={history}
					toggle={this.state.modalCards}
					reportClose={this.reportClose('modalCards')}
					afterSave={() => this.setState({refresh: !this.state.refresh, modalCards: false, key: Math.random()})}
					size={'md'}
					objectProps={{main_role: main_role, current_address: this.state.current_address, isAdmin: main_role <= 15, canSeeStatus: main_role === UserRoles.Admin}}
					submitLabel={"Submit"}
				/>
			</div>
		)
	}
}